import React, { useState } from 'react';
import {
  Container,
  MainHeading,
  FeaturesContainer,
  FeatureCard,
  FeatureIcon,
  FeatureTitle,
  FeatureDescription,
  LearnMoreButton,
  Arrow,
  IconImage,
  ExpandedContent,
  ExpandedTitle,
  ExpandedText,
  CloseButton,
  WordSliderContainer,
  WordSliderTrack,
  WordItem,
  PrefixText,
  MainWord
} from './styles';
import whatsappIcon from '../../../images/whatsappicon.png';
import challengeIcon from '../../../images/challenge-icon.png';
import correctionIcon from '../../../images/correction-icon.png';
import lines from '../../../images/lines.png';

const Section2 = () => {
  const [expandedCard, setExpandedCard] = useState(null);
  
  const features = [
    {
      id: 'whatsapp',
      icon: whatsappIcon,
      iconAlt: "WhatsApp Icon",
      title: "100% WhatsApp",
      description: "Será o suficiente para conseguir praticar todo dia.",
      expandedText: "Nosso método é completamente baseado no WhatsApp, permitindo que você pratique e aprenda o idioma diretamente em uma plataforma que você já usa diariamente. Não é necessário baixar aplicativos adicionais ou acessar sites. Você receberá exercícios, dicas, correções e todo o conteúdo necessário para seu aprendizado através de mensagens personalizadas, tornando o processo de aprendizado integrado à sua rotina digital."
    },
    {
      id: 'challenges',
      icon: challengeIcon,
      iconAlt: "Challenge Icon",
      title: "Desafios curtos",
      description: "Mas o necessário para você desenvolver o idioma.",
      expandedText: "Nossos desafios diários são criados especificamente para serem completados em poucos minutos, mas são estrategicamente elaborados para maximizar seu aprendizado. Cada desafio foca em um aspecto específico do idioma - vocabulário, gramática, pronúncia ou compreensão. A consistência desses pequenos exercícios ao longo do tempo produz resultados impressionantes, ajudando você a construir confiança e fluência gradualmente sem sobrecarregar sua agenda."
    },
    {
      id: 'correction',
      icon: correctionIcon,
      iconAlt: "Correction Icon",
      title: "Correção instantânea",
      description: "24 horas com assistente IA + dicas de pronúncia.",
      expandedText: "Nossa plataforma oferece um sistema de correção alimentado por IA que está disponível 24 horas por dia. Sempre que você enviar suas respostas ou tiver dúvidas, receberá feedback imediato com explicações detalhadas sobre seus erros e como corrigi-los. Além disso, fornecemos dicas de pronúncia específicas para ajudá-lo a melhorar seu sotaque e entonação, garantindo que seu aprendizado seja completo tanto na escrita quanto na fala."
    }
  ];

  const handleToggleExpand = (id) => {
    if (expandedCard === id) {
      setExpandedCard(null);
    } else {
      setExpandedCard(id);
    }
  };

  const motivationalPhrases = [
    { text: 'start where', color: '#FF6B35' },
    { text: 'you are.', color: '#7e57c2' },
    { text: 'use what', color: '#2563EB' },
    { text: 'you have.', color: '#2ECC71' },
    { text: 'do what', color: '#FF5470' },
    { text: 'you can.', color: '#FFC107' },
  ];

  const wordRotations = motivationalPhrases.map(phrase => ({
    word: phrase.text,
    color: phrase.color
  }));

  return (
    <Container>
      <IconImage id="beneficios" src={lines} alt="" />
      <MainHeading >
        Perfeito para quem não tem tempo e quer <span style={{ color: '#2563EB' }}>evoluir</span> ou aprender o idioma. Uma imersão diária.
      </MainHeading>
      
      <FeaturesContainer>
        {features.map((feature) => (
          <React.Fragment key={feature.id}>
            <FeatureCard>
              <FeatureIcon>
                <IconImage src={feature.icon} alt={feature.iconAlt} />
              </FeatureIcon>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>
                {feature.description}
              </FeatureDescription>
              <LearnMoreButton onClick={() => handleToggleExpand(feature.id)}>
                {expandedCard === feature.id ? 'Fechar' : 'Saiba Mais'}
                <Arrow>{expandedCard === feature.id ? '↑' : '→'}</Arrow>
              </LearnMoreButton>
            </FeatureCard>
            {expandedCard === feature.id && (
              <ExpandedContent>
                <ExpandedTitle>{feature.title}</ExpandedTitle>
                <ExpandedText>{feature.expandedText}</ExpandedText>
                <CloseButton onClick={() => setExpandedCard(null)}>Fechar</CloseButton>
              </ExpandedContent>
            )}
          </React.Fragment>
        ))}
      </FeaturesContainer>
      
      <WordSliderContainer>
      <WordSliderTrack>
        {[...wordRotations, ...wordRotations].map((item, index) => (
          <WordItem key={index}>
            <PrefixText>{item.prefix}</PrefixText>
            <MainWord color={item.color}>{item.word}</MainWord>
          </WordItem>
        ))}
      </WordSliderTrack>
      </WordSliderContainer>
    </Container>
  );
};

export default Section2;
